export class FullTextSearchManager {


    apiEndpoint: string
    currentQuery: string = ''
    store: number[]

    constructor(apiEndpoint: string) {
        this.store = []
        this.apiEndpoint = apiEndpoint
    }

    async prepareSearch(query: string) {
        this.store = []
        if (query !== '') {
            const results = await (await fetch(`${this.apiEndpoint}?search=${encodeURIComponent(query)}`, {
                method: 'POST'
            })).json()
            this.store = results
        }
        this.currentQuery = query
    }

    async matches(query: string, postId: number): Promise<boolean> {
        if (query != this.currentQuery) {
            await this.prepareSearch(query)
        }
        if (query === '') return true
        return this.store.includes(postId)
    }
}